import React, { useState, useEffect } from "react";
// import useSound from "use-sound";

import { FooterStyled, FooterSonic } from "./FooterStyled";

import { Stop } from "./StopFooter";
import FooterNormal from "./FooterNormal";
import SideOptions from "./SonicFooter/SideOptions";

import { LeftArrow, RightArrow, MainOptions } from "./FooterStyled";
import Sonic from "./SonicFooter/Sonic";

export default function Footer({
  betInfo,
  n,
  clickable,
  userSettings,
  isAutoOn,
  toggleIsAutoOn,
  play,
  random,
  handleClean,
  handleAbove,
  sendSelectedToApp,
  betCount,
  betTotal,
  handleNotification,
  toFix,
  minBet,
  maxBet,
  currency,
  gameMode,
  sound,
  music,
  volume,
}) {
  const [showOptions, setshowOptions] = useState(false);
  // const { gameMode } = userSettings;

  const [stopAnim, setStopAnim] = useState(false);

  const setStopAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 1000);
    }
  };
  const [showStop, setshowStop] = useState(false);
  useEffect(() => {
    if (isAutoOn) {
      setshowStop(true);
    } else {
      setTimeout(() => {
        setshowStop(false);
      }, 167);
    }
  }, [isAutoOn]);

  const [browser, setbrowser] = useState("chrome");
  const detectBrowser = () => {
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) !== -1
    ) {
      setbrowser("Opera");
    } else if (navigator.userAgent.indexOf("Edg") !== -1) {
      setbrowser("Edge");
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
      setbrowser("Chrome");
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
      setbrowser("Safari");
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
      setbrowser("Firefox");
    } else if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      !!document.documentMode === true
    ) {
      //IF IE > 10
      setbrowser("IE");
    } else {
      setbrowser("chrome");
    }
  };
  useEffect(() => {
    detectBrowser();
  }, []);

  const toggleShowOptions = () => setshowOptions((s) => !s);

  return (
    <FooterStyled className="FooterStyled">
      {showStop ? (
        <Stop
          setStopAnimation={() => setStopAnimation(stopAnim, setStopAnim)}
          stopAnim={stopAnim}
          gameMode={gameMode}
          isAutoOn={isAutoOn}
          betTotal={betTotal}
          betCount={betCount}
          toggleIsAutoOn={toggleIsAutoOn}
          bet={betInfo.betAmount}
          toFix={toFix}
          currency={currency}
        />
      ) : gameMode === "sonic" ? (
        <FooterSonic
          clickable={clickable}
          showOptions={showOptions}
          className="FooterSonic"
          isSafari={browser === "Safari"}
        >
          <SideOptions
            showOptions={showOptions}
            random={random}
            toggle={toggleShowOptions}
            clean={handleClean}
            handleNotification={handleNotification}
            toFix={toFix}
            minBet={minBet}
            maxBet={maxBet}
            currency={currency}
            sound={sound}
            volume={volume}
            n={n}
          />
          <MainOptions
            showOptions={showOptions}
            delay={showOptions ? "0ms" : "160ms"}
            toFix={toFix}
          >
            <LeftArrow click={toggleShowOptions} showOptions={showOptions} />
            <Sonic
              play={play}
              n={n}
              showOptions={showOptions}
              click={toggleShowOptions}
              handleNotification={handleNotification}
              toFix={toFix}
              minBet={minBet}
              maxBet={maxBet}
              currency={currency}
              volume={volume}
              sound={sound}
            />
            <RightArrow
              n={n}
              handleNotification={handleNotification}
              sound={sound}
              click={() => {
                if (n > 0) {
                  handleAbove("autorules");
                  sendSelectedToApp();
                }
              }}
            />
          </MainOptions>
        </FooterSonic>
      ) : (
        <FooterNormal
          n={n}
          play={play}
          clickable={clickable}
          handleAbove={handleAbove}
          random={random}
          clean={handleClean}
          sendSelectedToApp={sendSelectedToApp}
          handleNotification={handleNotification}
          toFix={toFix}
          minBet={minBet}
          maxBet={maxBet}
          currency={currency}
          volume={volume}
          sound={sound}
        />
      )}
    </FooterStyled>
  );
}
